export default {
  // Hero section
  'hero.title': 'Ferramentas Profissionais de Temporizador Online',
  'hero.subtitle': 'Escolha a ferramenta de cronometragem perfeita para suas necessidades',

  // Tool cards
  'timer.title': 'Temporizador',
  'timer.description': 'Temporizador de contagem regressiva para trabalho, estudo e vida',
  'timer.longDescription': 'Temporizador de contagem regressiva para produtividade, culinária e gestão de tempo',
  'timer.button': 'Iniciar Temporizador',

  'stopwatch.title': 'Cronômetro',
  'stopwatch.description': 'Ferramenta de cronometragem de alta precisão',
  'stopwatch.longDescription': 'Cronômetro de alta precisão para esportes, treinamento e cronometragem precisa',
  'stopwatch.button': 'Iniciar Cronômetro',

  'worldclock.title': 'Relógio Mundial',
  'worldclock.description': 'Visualize fusos horários ao redor do mundo',
  'worldclock.longDescription': 'Exibição em tempo real dos horários das principais cidades do mundo com cálculos inteligentes de fuso horário',
  'worldclock.button': 'Ver Relógio Mundial',

  // Features section
  'features.title': 'Por que escolher timer.today?',
  'features.reliable.title': 'Confiável e Preciso',
  'features.reliable.desc': 'Cronometragem com precisão de milissegundos com confiabilidade baseada no navegador',
  'features.crossPlatform.title': 'Multiplataforma',
  'features.crossPlatform.desc': 'Funciona perfeitamente em desktop, tablet e dispositivos móveis',
  'features.smartNotifications.title': 'Notificações Inteligentes',
  'features.smartNotifications.desc': 'Alertas sonoros e notificações na área de trabalho quando o tempo acabar',
  'features.easyToUse.title': 'Fácil de Usar',
  'features.easyToUse.desc': 'Interface limpa com controles intuitivos para todos os usuários',

  // Keywords section
  'keywords.timer': 'temporizador contagem regressiva pomodoro foco trabalho pausa',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};